import styled from 'styled-components';
import { darken } from 'polished';
import Colors from '../../theme/Colors';

export const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;

  max-width: 516px;
  width: 100%;
  max-height: 437px;
  margin: auto;

  display: flex;
  justify-content: center;
  align-items: center;

  color: ${Colors.grayDark};

  > div {
    width: 100%;
    max-width: 516px;
    max-height: 100vh;
    overflow: auto;
    background-color: #fff;
    border-radius: 16px;
    padding: 1.25rem;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  z-index: 99;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  h3 {
    font-weight: bold;
    margin: 0;
  }
`;

export const SubHeader = styled.header`
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  border-bottom: 1px solid #d1d1d1d1;
  margin-bottom: 12px;
  color: ${Colors.gray};

  p {
    margin-bottom: 6px;
  }
`;

export const TableContainer = styled.div`
  max-height: 200px;
  overflow: scroll;

  &::-webkit-scrollbar {
    width: 0;
  }
`;

export const Table = styled.table`
  width: 98%;
  margin: 0 auto;
  margin-bottom: 16px;

  > tr > th {
    font-weight: bold;
    font-size: 12px;
    padding-bottom: 6px;

    &:first-child {
      padding-left: 12px;
    }

    &:last-child {
      text-align: right;
      padding-right: 12px;
    }
  }

  > tr > td {
    font-size: 12px;
    padding: 4px;

    &:first-child {
      padding-left: 12px;
    }

    &:last-child {
      text-align: right;
      padding-right: 12px;
    }
  }
`;

export const Resume = styled.div`
  border-top: 1px solid #d1d1d1d1;
  padding: 12px 12px 0px 12px;
  color: ${Colors.green};

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: bold;
  }

  p {
    margin: 0;
    font-size: 16px;
    font-weight: bold;
  }

  > button {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    background-color: ${Colors.secondary};
    color: #fff;
    font-weight: bold;
    border-bottom: 4px solid ${darken(0.25, Colors.secondary)};
    outline: none;
    margin-top: 16px;
  }

  > button:disabled {
    opacity: 0.5;
  }
`;

export const SelectContainer = styled.main`
  /* margin-top: 16px; */
  border: 1px solid ${Colors.gray};
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 6px;
  width: 100%;

  select {
    width: 100%;
    color: ${Colors.grayDark};
    border: 0;
    outline: none;
    background: transparent;
  }
`;

export const InputContainer = styled.main`
  /* margin-top: 16px; */
  border: 1px solid ${Colors.gray};
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 6px;
  width: 100%;

  input {
    width: 100%;
    color: ${Colors.grayDark};
    border: 0;
    outline: none;
  }
`;

export const Error = styled.p`
  font-size: 14px !important;
  color: ${Colors.pink};
  text-align: center;
`;

export const AddressText = styled.p`
  font-size: 14px !important;
  color: #333;
  font-weight: normal !important;
  width: 100%;
`;
export const AddressButton = styled.button`
  background-color: transparent;
  color: ${Colors.pink};
  border: 0;
  text-align: right;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;

  &:focus {
    outline: none;
  }
`;

export const Payments = styled.section`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  label {
    margin: 0%;
    color: #696969;
  }

  > div {
    flex-direction: column;
    align-items: flex-start;
  }

  button {
    background: transparent;
    margin-bottom: 6px;
    height: 42px;
    min-width: 42px;
    border-radius: 8px;
    border: 1px solid #b4b4b4;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #696969;
    font-size: 20px;
  }
`;
